import React from "react";
import { View, StyleSheet, ScrollView, ActivityIndicator } from "react-native";
import CustomText from "../../../common/general/CustomText/CustomText";
import CustomSpacing from "../../../common/layout/CustomSpacing/CustomSpacing";
import CustomButton from "../../../common/general/CustomButton/CustomButton";
import LoadingOverlay from "../../../common/status/LoadingOverlay/LoadingOverlay";
import { Pen } from "@phosphor-icons/react";

const FormLayout = ({
  children,
  title,
  subtitle = null,
  isSubmitting,
  onCancel,
  onSubmit,
  actionText = "Save",
  disableSubmit = false,
  error = null,
  loadingConfig = null,
  isAssignment = false,
  onAddWorksheet = null,
  activityData = null,
  buttonsContainerStyle = {},
  submitButtonStyle = {},
  cancelButtonStyle = {},
  contentContainerStyle = {},
  hasButtonLoader = false,
}) => {
  return (
    <View style={styles.container}>
      {loadingConfig && (
        <LoadingOverlay
          visible={loadingConfig.visible}
          step={loadingConfig.step}
          progress={loadingConfig.progress}
          message={loadingConfig.message}
          isCancellable={loadingConfig.isCancellable}
          onCancel={loadingConfig.onCancel}
        />
      )}

      <View style={styles.header}>
        <CustomText text={title} size="xl" weight="bold" style={{ paddingHorizontal: 32 }} useTranslationText={false} />
        {subtitle && (
          <CustomText
            text={subtitle}
            size="m"
            style={{ paddingHorizontal: 32, paddingTop: 4, color: "#667085" }}
            useTranslationText={false}
          />
        )}
      </View>

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={true}>
        <View style={[styles.content, contentContainerStyle]}>
          <CustomSpacing type="vertical" size="xl" />
          {children}

          {error && (
            <>
              <CustomSpacing type="vertical" size="m" />
              <CustomText text={error} size="m" useTranslationText={false} style={styles.errorText} />
            </>
          )}

          <View style={[styles.buttons, buttonsContainerStyle]}>
            <CustomButton
              text="Cancel"
              styleType="primaryTransparentStroke"
              size="s"
              textStyle={{ fontSize: 14, fontWeight: 700 }}
              style={[styles.cancelButton, cancelButtonStyle]}
              onPress={onCancel}
              disabled={isSubmitting}
            />
            <CustomSpacing type="horizontal" size="s" />
            <View style={styles.actionButtons}>
              {isAssignment && (
                <CustomButton
                  text={activityData?.worksheet?.id ? "Edit Worksheet" : "Add Worksheet"}
                  size="s"
                  textStyle={{ fontSize: 14, fontWeight: 700, color: "#3E68FE" }}
                  onPress={onAddWorksheet}
                  leftIcon={<Pen size={16} color="#3E68FE" />}
                  styleType="primaryTransparentStroke"
                  disabled={disableSubmit || isSubmitting}
                  style={disableSubmit || isSubmitting ? { backgroundColor: "#ccc" } : {}}
                />
              )}
              {hasButtonLoader && isSubmitting ? (
                <ActivityIndicator
                  size="small"
                  color="#fff"
                  style={[styles.loader, { backgroundColor: "#ccc" }, submitButtonStyle]}
                />
              ) : (
                <CustomButton
                  text={actionText}
                  size="s"
                  textStyle={{ fontSize: 14, fontWeight: 700 }}
                  onPress={onSubmit}
                  styleType="primary"
                  disabled={disableSubmit || isSubmitting}
                  style={disableSubmit || isSubmitting ? { backgroundColor: "#ccc" } : submitButtonStyle}
                />
              )}
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: "100%",
  },
  header: {
    paddingVertical: 32,
    backgroundColor: "#F2F4F7",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    flexGrow: 1,
  },
  content: {
    paddingHorizontal: 32,
    paddingBottom: 40,
  },
  buttons: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 24,
    width: "100%",
  },
  errorText: {
    color: "#FF0000",
    marginTop: 8,
  },
  actionButtons: {
    flex: 1,
    justifyContent: "flex-end",
    gap: 16,
    flexDirection: "row",
  },
  loader: {
    marginRight: 8,
  },
  cancelButton: {
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#ccc",
  },
});

export default FormLayout;
